/**
*
* PolarRating
*
*/

import React from 'react';
import {Polar} from 'react-chartjs-2';

function PolarRating(props) {
	const data = {
	  datasets: [{
	    data: [
	      0,
	      0,
	      0,
	      0,
	    ],
	    backgroundColor: [
	      'red',
	      'yellow',
	      'green',
	      'blue',
	    ],
	    label: 'My dataset' // for legend
	  }],
	  labels: [
	    'Czerwony',
	    'Żółty',
	    'Zielony',
	    'Niebski',
	  ]
	};
    data.datasets[0].data = [props.red, props.yellow, props.green, props.blue]
  return (
    <div>
      <Polar data={data} />
    </div>
  );
}

PolarRating.propTypes = {

};

export default PolarRating;